// extracted by mini-css-extract-plugin
export default {"container":"Question_container__gKBnX","header":"Question_header__GRpv5","title":"Question_title__LeTOg","index":"Question_index__BlgIH","links":"Question_links__lu-Cg"};